import { connect } from 'react-redux';
import { resetSubmitForm, resetSubmitFormData, getSubmitFormSuccessStatus, getSubmitFormError, getSubmitFormFetchingStatus } from './../../../reducers/common/submitForm';
import FormWrapper from './FormWrapper';
import {getTranslation} from "../../../reducers/common/localization";

const mapStateToProps = state => {
    return {       
        error: getSubmitFormError(state),
        fetching: getSubmitFormFetchingStatus(state),
        success: getSubmitFormSuccessStatus(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onResetState: () => {
            dispatch(resetSubmitFormData());
        },
        onCloseAlert: () => {
            dispatch(resetSubmitForm());
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FormWrapper);



// WEBPACK FOOTER //
// ./src/components/commonComponents/formWrapper/FormWrapper.container.js